import {Component, Emitter, Object3D, PhysXComponent} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {globalAudioManager} from '@wonderlandengine/spatial-audio';
import {Sounds} from '../utils/Audio';

import type {GameAnalytics as GA} from 'gameanalytics';
declare var GameAnalytics: typeof GA;

/**
 * portal
 */
export class Portal extends Component {
    static TypeName = 'portal';
    static onTeleport: Emitter<[number[]]> = new Emitter();

    /* Properties that are configurable in the editor */

    @property.object()
    player!: Object3D;

    @property.object()
    target!: Object3D;

    @property.string()
    portalFrom!: string;

    @property.string()
    portalTo!: string;

    start() {
        const physx = this.object.getComponent(PhysXComponent);
        const playerPhysx = this.player.getComponent(PhysXComponent);
        if (physx && playerPhysx) {
            physx.onCollisionWith(playerPhysx, this.onCollision.bind(this));
        }
    }

    onCollision() {
        console.log(this.target.getPositionWorld([]));
        Portal.onTeleport.notify(this.target.getPositionWorld([]));

        GameAnalytics.addDesignEvent(`portal:${this.portalFrom}:${this.portalTo}`);

        globalAudioManager.playOneShot(Sounds.Portal, {volume: 0.3});
    }
}
